import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./OrderEntries.css"; // Make sure to create this CSS file
import NewOrderEntryModal from "./NewOrderEntryModal";
import { FaRegStickyNote } from "react-icons/fa";

import { useAuth } from "../AuthContext";

const OrderEntries = () => {
  const [dispatchEntries, setDispatchEntries] = useState([]);
  const [showNewEntryModal, setShowNewEntryModal] = useState(false);

  const [customers, setCustomers] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const { mobile } = useAuth();

  const [filterNotPacked, setFilterNotPacked] = useState(false);
  const [filterUrgent, setFilterUrgent] = useState(false);
  const [filterNotDispatched, setFilterNotDispatched] = useState(false);
  const [filterPackAndHold, setFilterPackAndHold] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  const dispatchEmployees = [
    "AKHILESH",
    "AMAN OLD",
    "ANKIT",
    "ARUN ",
    "ARVIND",
    "ASHWINI",
    "DEEPAK",
    "HARIKESH",
    "HARSHITAMBE",
    "KAMAL",
    "MOHIT",
    "NAVJOT",
    "PAPPU",
    "RAHUL OLD",
    "RAHULDEOL",
    "SALMAN",
    "SANGAM",
    "SUNIL",
    "SURAJ",
    "VISHAL",
    "VIVEK",
  ];

  const salesEmployees = [
    "Aarti",
    "Aarti Sharma",
    "Ajay",
    "Akshay",
    "Anil",
    "Dolly",
    "Gobind",
    "Jyoti",
    "Lovish",
    "Manpreet",
    "Neetu",
    "Pankaj Bhatt",
    "Pankaj Rawat",
    "Prabhjot",
    "Priya",
    "Rajneesh",
    "Sanju",
    "Sarita",
    "Satyam",
    "Shreya",
    "Suman",
    "Tarun",
    "Usha",
    "Yashika",
  ];

  const paymentStatusOptions = [
    "Received",
    "Credit",
    "Pack & Hold",
    "DOD",
    "COD",
    "Self",
    "Advance",
    "Credit by MD",
    "Rejected",
    "Replacement",
  ];
  const [showPriorityDropdown, setShowPriorityDropdown] = useState({});
  const [showPaymentStatusDropdown, setShowPaymentStatusDropdown] = useState(
    {}
  );
  const [showEmployeeDropdown, setShowEmployeeDropdown] = useState({});

  const handleDropdownIconClick = (e, toggleFunction, id) => {
    const currentScrollPosition = window.scrollY;
    e.preventDefault();
    e.stopPropagation();
    toggleFunction(id);
    requestAnimationFrame(() => {
      window.scrollTo({ top: currentScrollPosition });
    });
  };

  const togglePriorityDropdown = (id) => {
    setShowPriorityDropdown((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const toggleEmployeeDropdown = (id) => {
    setShowEmployeeDropdown((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleEmployeeChange = async (e, id) => {
    const newEmployee = e.target.value;
    try {
      await axios.patch(
        `${process.env.REACT_APP_API_URL}/api/order-entries/employee/${id}`,
        {
          sales_employee: newEmployee,
        }
      );
      setDispatchEntries((currentEntries) =>
        currentEntries.map((entry) => {
          if (entry.id === id) return { ...entry, sales_employee: newEmployee };
          return entry;
        })
      );
      setShowEmployeeDropdown((prevState) => ({ ...prevState, [id]: false }));
    } catch (error) {
      console.error("Failed to update employee", error);
    }
  };

  const togglePaymentStatusDropdown = (id) => {
    setShowPaymentStatusDropdown((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  // Calculation for summaries
  const currentDate = new Date().toISOString().slice(0, 10); // "YYYY-MM-DD"
  // Calculate today's pending orders
  const todayOrderPending = dispatchEntries.filter(
    (entry) =>
      entry.date_time_of_order_given.slice(0, 10) === currentDate &&
      !entry.order_packed_by &&
      entry.payment_status !== "Rejected"
  ).length;

  // Calculate previous pending orders
  const previousOrderPending = dispatchEntries.filter(
    (entry) =>
      entry.date_time_of_order_given.slice(0, 10) < currentDate &&
      !entry.order_packed_by &&
      entry.payment_status !== "Rejected"
  ).length;
  const totalOrdersCameToday = dispatchEntries.filter(
    (entry) => entry.date_time_of_order_given.slice(0, 10) === currentDate
  ).length;

  const totalOrdersPackedToday = dispatchEntries.filter(
    (entry) =>
      entry.order_packed_date_time &&
      entry.order_packed_date_time.slice(0, 10) === currentDate
  ).length;

  const pendingOrdersToBePacked = dispatchEntries.filter(
    (entry) =>
      !entry.order_packed_by &&
      !entry.dispatch_status &&
      entry.payment_status !== "Rejected"
  ).length;

  const handlePriorityChange = async (e, id) => {
    const newPriority = e.target.value;
    // Call backend to update priority
    try {
      await axios.patch(
        `${process.env.REACT_APP_API_URL}/api/order-entries/priority/${id}`,
        { priority: newPriority }
      );

      setDispatchEntries((currentEntries) =>
        currentEntries.map((entry) => {
          if (entry.id === id)
            return { ...entry, priority_of_order: newPriority };
          return entry;
        })
      );
      setShowPriorityDropdown((prevState) => ({ ...prevState, [id]: false })); // Close the dropdown
      // Fetch updated entries or directly update local state for immediate UI feedback
    } catch (error) {
      console.error("Failed to update priority", error);
    }
  };

  const handlePaymentStatusChange = async (e, id) => {
    const newPaymentStatus = e.target.value;
    // Call backend to update payment status
    try {
      await axios.patch(
        `${process.env.REACT_APP_API_URL}/api/order-entries/payment-status/${id}`,
        { paymentStatus: newPaymentStatus }
      );
      setDispatchEntries((currentEntries) =>
        currentEntries.map((entry) => {
          if (entry.id === id)
            return { ...entry, payment_status: newPaymentStatus };
          return entry;
        })
      );
      setShowPaymentStatusDropdown((prevState) => ({
        ...prevState,
        [id]: false,
      })); // Close the dropdown
      // Fetch updated entries or directly update local state for immediate UI feedback
    } catch (error) {
      console.error("Failed to update payment status", error);
    }
  };
  // Handler to update search term state
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const bottomRef = useRef(null);

  const filteredEntries = dispatchEntries.filter((entry) => {
    const matchesSearch =
      entry.party_name.toLowerCase().includes(searchTerm) ||
      entry.sales_employee.toLowerCase().includes(searchTerm);
    const matchesNotPacked =
      !filterNotPacked ||
      (!entry.order_packed_by && entry.payment_status !== "Rejected");
    const matchesUrgent =
      !filterUrgent ||
      (entry.priority_of_order === "Urgent" &&
        (!entry.order_packed_by || !entry.dispatch_status)); // Assuming 'Urgent' is the term used for urgency
    const matchesNotDispatched =
      !filterNotDispatched || (!entry.dispatch_status && entry.order_packed_by);
    const matchesPackAndHold =
      !filterPackAndHold || entry.payment_status === "Pack & Hold";
    return (
      matchesSearch &&
      matchesNotPacked &&
      matchesUrgent &&
      matchesNotDispatched &&
      matchesPackAndHold
    );
  });

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView(false);
    }
  }, [customers]);

  // const fetchDispatchEntries = async () => {
  //   // if (!initialLoadComplete) {
  //   //   setIsLoading(true);
  //   // }
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL}/api/order-entries`
  //     );
  //     const sortedEntries = response.data.sort(
  //       (a, b) => new Date(a.id) - new Date(b.id)
  //     );
  //     setDispatchEntries(sortedEntries);
  //     // setIsLoading(false);
  //     // setInitialLoadComplete(true);
  //   } catch (error) {
  //     console.error("Failed to fetch dispatch entries", error);
  //     setError("Failed to load dispatch entries.");
  //     // setIsLoading(false);
  //   }
  // };

  const fetchDispatchEntries = async () => {
    const params = searchTerm
      ? `?searchTerm=${encodeURIComponent(searchTerm)}`
      : "";
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/order-entries${params}`
      );
      const sortedEntries = response.data.sort((a, b) => a.id - b.id);
      setDispatchEntries(sortedEntries);
    } catch (error) {
      console.error("Failed to fetch dispatch entries", error);
      setError("Failed to load dispatch entries.");
    }
  };

  useEffect(() => {
    fetchDispatchEntries();
  }, [searchTerm]);

  useEffect(() => {
    const fetchCustomers = async () => {
      // if (!initialLoadComplete) {
      //   setIsLoading(true);
      // }
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/customers-names`
        );
        setCustomers(response.data);
        // setIsLoading(false);
        // setInitialLoadComplete(true);
      } catch (error) {
        console.error("Failed to fetch customers", error);
        setError("Failed to load customer data.");
        // setIsLoading(false);
      }
    };
    // Function to fetch dispatch entries from the backend

    fetchDispatchEntries();
    fetchCustomers();

    let interval;
    // Set up an interval to fetch data every 120 seconds only for specified users
    if (mobile === "9041677932" || mobile === "8725092149") {
      interval = setInterval(fetchDispatchEntries, 90000); // 120000 ms = 120 seconds
    }

    // Clear the interval when the component unmounts or the mobile number changes
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  const handleNewEntrySubmit = async (entryData) => {
    // Function to submit a new order entry to the backend
    try {
      // Adjusting the endpoint to submit to the correct API for order entries
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/order-entries`,
        entryData
      );
      setShowNewEntryModal(false);
      // Fetching the updated list of order entries to ensure the UI is up to date
      fetchDispatchEntries();
      setPopupMessage("Order Entry Successful!");
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000); // Hide popup after 3 seconds
    } catch (error) {
      console.error("Failed to submit new order entry", error);
      // Optionally, you could set an error message to be displayed to the user here
    }
  };

  const handlePackedByChange = async (e, orderId) => {
    const packedBy = e.target.value;
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/api/order-entries/packed-by/${orderId}`,
        { packedBy }
      );
      // Success handling
      console.log(response.data.message);
      // Optionally, refresh the order entries list here to reflect the update
      fetchDispatchEntries();

      setPopupMessage("Packing Status updated successfully!");
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } catch (error) {
      console.error("Failed to update Packed By:", error);
      // Error handling
    }
  };

  const handleDispatchStatusChange = async (orderId, packedBy) => {
    try {
      if (!packedBy) {
        // Show popup and prevent further execution
        setPopupMessage("Order is not Packed Yet!");
        setShowPopup(true);
        setTimeout(() => setShowPopup(false), 3000);
        return; // Prevent checking the box and updating the status
      }

      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/api/order-entries/dispatch-status/${orderId}`
      );
      // Success handling
      console.log(response.data.message);
      // Optionally, refresh the order entries list here to reflect the update
      // Optionally, refresh the order entries list here to reflect the update
      fetchDispatchEntries();

      setPopupMessage("Dispatch Status updated successfully!");
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } catch (error) {
      console.error("Failed to update Dispatch Status:", error);
      // Error handling
    }
  };

  // Assuming you've fetched the customer names into 'customers'
  const isCustomerNameValid = (partyName) => {
    return customers.some((customer) => customer.customer_name === partyName);
  };

  const formatDate = (dateString) => {
    if (!dateString) return ""; // Return empty string if date is null
    const date = new Date(dateString);
    const pad = (num) => num.toString().padStart(2, "0");
    return `${pad(date.getDate())}/${pad(
      date.getMonth() + 1
    )}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const renderEntriesTable = () => (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            <th>Id</th>
            <th>Party Name</th>
            <th>Employee</th>
            <th>Order Date</th>
            <th>Mode</th>
            <th>Company</th>
            {mobile === "9041677932" && <th>Value</th>}
            <th>Category</th>
            <th>Priority</th>
            <th>Payment Status</th>
            <th>Packed By</th>
            <th>Packed Date</th>
            <th>Dispatch Status</th>
            <th>Dispatch Date</th>
          </tr>
        </thead>
        <tbody>
          {filteredEntries.map((entry, index) => {
            const partyNameValid = isCustomerNameValid(entry.party_name);
            let bgColor = ""; // Default no background color
            if (entry.payment_status === "Rejected") {
              bgColor = "#ff69b4"; // Dark pink for rejected payment status
            } else if (!entry.order_packed_by && !entry.dispatch_status) {
              bgColor = "#ffcccc"; // Light red for both fields empty
            } else if (entry.order_packed_by && !entry.dispatch_status) {
              bgColor = "#ffffcc"; // Light yellow for only packed by filled
            } else if (entry.order_packed_by && entry.dispatch_status) {
              bgColor = "#ccffcc"; // Light green for both fields filled
            }
            let isLastItem = index === filteredEntries.length - 1;

            return (
              <tr
                key={entry.id}
                style={{ backgroundColor: bgColor }}
                title={entry.remarks || ""}
                ref={isLastItem ? bottomRef : null} // Attach ref to last item
              >
                <td style={{ textAlign: "center" }}>{entry.id}</td>
                <td
                  className={!partyNameValid ? "party-name-not-in-list" : ""}
                  style={{ textAlign: "center" }}
                >
                  {entry.party_name}
                  {entry.remarks && (
                    <FaRegStickyNote className="remarks-icon" />
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {entry.sales_employee}
                  {mobile === "9041677932" && !entry.dispatch_status && (
                    <>
                      <span
                        className="dropdown-icon"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleEmployeeDropdown(entry.id);
                        }}
                      >
                        ▼
                      </span>
                      {showEmployeeDropdown[entry.id] && (
                        <select
                          value={entry.sales_employee}
                          onChange={(e) => handleEmployeeChange(e, entry.id)}
                        >
                          {salesEmployees.map((employee) => (
                            <option key={employee} value={employee}>
                              {employee}
                            </option>
                          ))}
                        </select>
                      )}
                    </>
                  )}
                  {entry.is_pharmaflow === "Yes" && (
                    <div className="highlighted-row">(PharmaFlow)</div>
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {formatDate(entry.date_time_of_order_given)}
                </td>
                <td style={{ textAlign: "center" }}>
                  {entry.mode_of_transport}
                </td>
                <td style={{ textAlign: "center" }}>{entry.company_name}</td>
                {mobile === "9041677932" && (
                  <td style={{ textAlign: "center" }}>
                    {entry.value_of_order}/-
                  </td>
                )}
                <td style={{ textAlign: "center" }}>
                  {entry.category_of_order}
                </td>
                <td style={{ textAlign: "center" }}>
                  {entry.priority_of_order}
                  {!entry.order_packed_by &&
                    !entry.dispatch_status &&
                    mobile === "9041677932" && (
                      <span
                        className="dropdown-icon"
                        onClick={(e) =>
                          handleDropdownIconClick(
                            e,
                            togglePriorityDropdown,
                            entry.id
                          )
                        }
                      >
                        ▼
                      </span>
                    )}
                  {showPriorityDropdown[entry.id] && (
                    <select
                      value={entry.priority_of_order}
                      onChange={(e) => handlePriorityChange(e, entry.id)}
                    >
                      <option value="Normal">Normal</option>
                      <option value="Urgent">Urgent</option>
                    </select>
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {entry.payment_status}
                  {!entry.dispatch_status && mobile === "9041677932" && (
                    <span
                      className="dropdown-icon"
                      onClick={(e) =>
                        handleDropdownIconClick(
                          e,
                          togglePaymentStatusDropdown,
                          entry.id
                        )
                      }
                    >
                      ▼
                    </span>
                  )}
                  {showPaymentStatusDropdown[entry.id] && (
                    <select
                      value={entry.payment_status}
                      onChange={(e) => handlePaymentStatusChange(e, entry.id)}
                    >
                      {paymentStatusOptions.map((status) => (
                        <option key={status} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {entry.order_packed_by ? (
                    entry.order_packed_by
                  ) : mobile === "8725092149" &&
                    entry.payment_status !== "Rejected" ? (
                    <select
                      value=""
                      onChange={(e) => handlePackedByChange(e, entry.id)}
                    >
                      <option value="">Employee</option>
                      {dispatchEmployees.map((employee) => (
                        <option key={employee} value={employee}>
                          {employee}
                        </option>
                      ))}
                    </select>
                  ) : (
                    ""
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {formatDate(entry.order_packed_date_time)}
                </td>
                <td style={{ textAlign: "center" }}>
                  {entry.dispatch_status === "Done" ? (
                    `Done`
                  ) : mobile === "8725092149" ? (
                    <input
                      type="checkbox"
                      onChange={() =>
                        handleDispatchStatusChange(
                          entry.id,
                          entry.order_packed_by
                        )
                      }
                      disabled={
                        !entry.order_packed_by ||
                        entry.payment_status === "Pack & Hold"
                      }
                    />
                  ) : (
                    ""
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  {formatDate(entry.dispatch_date_time)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="order-page">
      {/* {isLoading && !initialLoadComplete && (
        <div className="loading-container">
          <div className="spinner"></div>
        </div>
      )} */}
      {/* {error && <div className="error-message">{error}</div>} */}
      {showPopup && <div className="popup-message">{popupMessage}</div>}
      {/* {!isLoading && !error && (
        <> */}
      <div className="top-bar">
        <input
          type="text"
          placeholder="Search..."
          onChange={handleSearchChange}
          className="search-bar"
        />
        <div className="summary-container">
          <span>
            <strong>Orders Today:</strong> {totalOrdersCameToday}
          </span>
          <span>
            <strong>Packed Today:</strong> {totalOrdersPackedToday}
          </span>
          <span className="highlighted-row">
            <strong>Pending Orders:</strong> {pendingOrdersToBePacked}
          </span>
          <span>
            <strong>Today Pending:</strong> {todayOrderPending}
          </span>
          <span>
            <strong>Yesterday Pending:</strong> {previousOrderPending}
          </span>
        </div>
        <div className="filter-container">
          <label>
            <input
              type="checkbox"
              checked={filterNotPacked}
              onChange={(e) => setFilterNotPacked(e.target.checked)}
            />{" "}
            Not Packed
          </label>
          <label>
            <input
              type="checkbox"
              checked={filterUrgent}
              onChange={(e) => setFilterUrgent(e.target.checked)}
            />{" "}
            Urgent Orders
          </label>
          <label>
            <input
              type="checkbox"
              checked={filterNotDispatched}
              onChange={(e) => setFilterNotDispatched(e.target.checked)}
            />{" "}
            Not Dispatched
          </label>
          <label>
            <input
              type="checkbox"
              checked={filterPackAndHold}
              onChange={(e) => setFilterPackAndHold(e.target.checked)}
            />{" "}
            Pack & Hold
          </label>
        </div>
        {mobile === "9041677932" && (
          <button onClick={() => setShowNewEntryModal(true)}>New Entry</button>
        )}
      </div>
      {renderEntriesTable()}
      {showNewEntryModal && (
        <NewOrderEntryModal
          customers={customers}
          onSubmit={handleNewEntrySubmit}
          onClose={() => setShowNewEntryModal(false)}
        />
      )}
      {/* </>
      )} */}
    </div>
  );
};

export default OrderEntries;
